export enum PhotoViewType {
  SUIVI = 'suivi',
  MISSON = 'mission',
}

export enum PhotoResponseType {
  ERR = 'ERR',
  INFOR = 'INFOR',
}
